/**
 * SelectRectOverlay (issue #16 Phase H-2)
 *
 * 範囲選択 drag 中に表示するオレンジ矩形 UI。
 * Desktop / Mobile 両方の page で同じ JSX を描画するため共通化 (DRY)。
 *
 * spec: docs/superpowers/specs/2026-06-01-issue-16-phase-h-design.md §6.5
 * plan: docs/superpowers/plans/2026-06-01-issue-16-phase-h.md §2.3
 *
 * 元 inline: FingeringEditorPageDesktop.tsx L183-197 (Phase 8a)。
 * 色・破線・pointerEvents="none"・page===currentPage ガード・data-testid を完全維持。
 */
import React from 'react';
import type { SelectRectState } from '../../../../hooks/useRangeSelection';

interface SelectRectOverlayProps {
  selectRectVisible: SelectRectState | null;
  currentPage: number;
}

const SelectRectOverlay: React.FC<SelectRectOverlayProps> = ({ selectRectVisible, currentPage }) => {
  if (!selectRectVisible || selectRectVisible.page !== currentPage) return null;
  return (
    <rect
      data-testid="select-rect-visible"
      x={Math.min(selectRectVisible.startSvgX, selectRectVisible.currentSvgX)}
      y={Math.min(selectRectVisible.startSvgY, selectRectVisible.currentSvgY)}
      width={Math.abs(selectRectVisible.currentSvgX - selectRectVisible.startSvgX)}
      height={Math.abs(selectRectVisible.currentSvgY - selectRectVisible.startSvgY)}
      fill="rgba(245, 158, 11, 0.1)"
      stroke="#f59e0b"
      strokeWidth={0.6}
      strokeDasharray="2 1"
      pointerEvents="none"
    />
  );
};

export default SelectRectOverlay;
